// @flow
import React, {Component} from 'react';
import type {Node} from 'react';
import {once as myOnce, shuffle} from '../../utility/utility.js';
import type {MultiChoiceFieldsType} from '../../types.js';
import styles from './MultiChoiceAssessment.module.css';
import formStyle from "../../styles/form.module.css";
import correct from './assets/checked.svg';
import inCorrect from './assets/bleach-sign.svg';

type PropsType = {
  assessment: MultiChoiceFieldsType,
  handleClick: ({id: string, isCorrect: boolean}) => void,
  id: string,
  submitted: boolean,
  index: number,
};

export const MultiChoiceAssessment = (props: PropsType): Node => (
  <div className={`${styles.component} ${'compEl'}`} data-index={props.index} data-assestment-id={props.id}>
    <div className={`${styles.question} fontTisa`}>
      <h4>{props.index}. {props.assessment.field_question[0].value.replace(/(<([^>]+)>)/ig,"")}</h4>
    </div>
    <div className={`${styles.choices} fontTisa`}>
      <MultipleChoiceList
        choices={
          [props.assessment.field_correct_choice[0],
          ...props.assessment.field_incorrect_choices,
          ].reduce((
            acc: [] | Array<{choice: {value: string}, isCorrect: boolean}>,
            choice: {value: string},
            i: number
          ): Array<{choice: {value: string}, isCorrect: boolean }> => {
          return [...acc, {
            choice,
            isCorrect: i < 1 ? true : false,
          }];
          }, [])
        }
        handleClick={props.handleClick}
        id={props.id}
        submitted={props.submitted} />
    </div>
  </div>
);

type MultipleChoiceListType = {
  choices: Array<{
    choice: {value: string},
    isCorrect: boolean,
  }>,
  handleClick: ({id: string, isCorrect: boolean}) => void,
  id: string,
  submitted: boolean,
};

type StateMultipleChoiceListType = {
  selectedId: string,
};

class MultipleChoiceList extends Component<
  MultipleChoiceListType,
  StateMultipleChoiceListType
> {
  constructor(props: MultipleChoiceListType) {
    super(props);
    this.state = {
      selectedId: '',
    };
  }
  shuffleOnce = myOnce((children: Array<Node>): Array<Node> => {
    return shuffle(children);
  });
  handleChoice = (
    choice: {id: string, isCorrect: boolean},
    choiceRef: string
  ) => {
    if (!this.props.submitted) {
      this.props.handleClick(choice);
      this.setState({
        selectedId: choiceRef,
      });
    }

    const el = document.querySelectorAll('.compEl');
    const currentPos = (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);


    let currentIndex = document.querySelectorAll("[data-assestment-id='" + this.props.id + "']");

      if(currentIndex[0].dataset.index < el.length){
          let finalRes = el[currentIndex[0].dataset.index].offsetTop;
          window.setTimeout(function() {
              document.documentElement.scrollTo({
                  top: finalRes - 70,
                  behavior: 'smooth',
              });}, 0);
      }
  }

  componentWillUpdate() {
    // reset, so highlighted choice
    // isn't selected anymore
    if (this.props.submitted) {
      this.setState({
        selectedId: '',
      });
    }
  }
  // add another click here for selectio
  render(): * {
    return (
      this.shuffleOnce(this.props.choices).map((
        choice: {choice: {value: string}, isCorrect: boolean},
        i: number
      ): Node => {
        return <Choice
          key={i}
          text={choice.choice}
          isCorrect={choice.isCorrect}
          index={this.props.index}
          id={this.props.id}
          submitted={this.props.submitted}
          selectedId={this.state.selectedId}
          handleChoice={this.handleChoice}
          choiceRef={i + ''} />;
      })
    );
  }
}

type ChoiceType = {
  text: {value: string},
  isCorrect: boolean,
  // handleClick: ({id: string, isCorrect: boolean}) => void,
  id: string,
  submitted: boolean,
  selectedId: string,
  handleChoice: ({id: string, isCorrect: boolean}, choiceRef: string) => void,
  choiceRef: string,
};


const Choice = ({
  text,
  isCorrect,
  id,
  index,
  submitted,
  selectedId,
  handleChoice,
  choiceRef,
}: ChoiceType): Node => {
  return (
    <div
        ref={ re => { this.myRef = re } }
        onClick={(): void => handleChoice({
        isCorrect,
        id,
      }, choiceRef)}
         className={`${formStyle.ctaButtonBorder} ${styles.choice}`}
      style={{
        fontWeight: selectedId === choiceRef ? '700' : '400',
        color: selectedId === choiceRef ? '#333' : '#6d8ebf',
        background: selectedId === choiceRef ? '#fff' : null,
      }}>

        <p className={styles.btnPar}>{text.value}</p> <span style={{
          display: submitted ? 'inline' : 'none',
          color: isCorrect ? 'green' : 'red',
        }}><img className={styles.answerIcon} src={isCorrect ? correct : inCorrect} alt={'answer icon'}/></span>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/AssessmentComponents/MultiChoiceAssessment.js